export default __webpack_public_path__ + "static/media/triste.c4d83870.gif";